import { render, staticRenderFns } from "./SortList.vue?vue&type=template&id=f3e7edd2&scoped=true&"
import script from "./SortList.vue?vue&type=script&lang=js&"
export * from "./SortList.vue?vue&type=script&lang=js&"
import style0 from "./SortList.vue?vue&type=style&index=0&id=f3e7edd2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e7edd2",
  null
  
)

export default component.exports